import { render, staticRenderFns } from "./FpuiAccordion.vue?vue&type=template&id=055194c4&lang=pug&"
import script from "./FpuiAccordion.vue?vue&type=script&lang=js&"
export * from "./FpuiAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports